var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}},[_c('path',{attrs:{"d":"M15 9l-4.8-5.25v2.625C7.8 6.375 3 7.949 3 14.25c0-.875 1.441-2.625 7.2-2.625v2.625zm0 0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round","stroke":"#fff","fill":"#fff"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }